module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_1-3.06cebc15.svg";